<template>
  <div class="section-scroll section-view section-offset-bottom front-selection">
    <div class="section-view-title">
      <div class="section-view-title-content section-view-title-content--flex">
        Подборки растений
        <div class="rr-products-arrows">
          <div class="rr-products-arrow" @click="previous()">
            <svg viewBox="0 0 22 38" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.9706 2.02944L3 19L19.9705 35.9706" stroke-width="4" stroke-linecap="round"></path>
            </svg>
          </div>
          <div class="rr-products-arrow" @click="next()">
            <svg viewBox="0 0 23 38" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.63881 2.02944L19.6094 19L2.63885 35.9706" stroke-width="4" stroke-linecap="round"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="front-selection-row">
      <div class="front-selection-text">
        Мы скомплектовали для вас растения по группам,<br>
        чтобы вам было проще определиться с выбором нужного вида
      </div>
      <a href="/selection" class="btn-main btn-big">
        <span class="btn-main-overlay">
          <span class="btn-main-content">
            Смотреть все подборки
          </span>
        </span>
        <span class="btn-main-shadow"></span>
      </a>
    </div>
    <div class="reviews-block">
      <flickity class="front-selection-slider" ref="flickity" :options="options" v-images-loaded="loaded">
        <div class="front-selection-slide" v-for="item in list" :key="item.id" v-html="item.html"></div>
      </flickity>
    </div>
  </div>
</template>

<script>
import imagesLoaded from 'vue-images-loaded';
import axios from 'axios';

export default {
  name: 'FrontSelection',
  directives: { imagesLoaded },
  data() {
    return {
      list: [],
      options: {
        contain: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: false,
        cellAlign: 'left'
      }
    }
  },
  created() {
    axios.get('/selection/get').then((response) => {
      this.list = response.data.list || [];
      this.$nextTick(() => {
        this.$refs.flickity.rerender();
      });
    });
  },
  methods: {
    loaded() {
      this.$refs.flickity.reloadCells();
    },
    next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    }
  }
}
</script>